/* eslint-disable no-undef */
/*
 * Golang has no null value for dates and uses "0001-01-01T00:00:00Z" or "0000-01-01T00:00:00Z" instead.
 * So a date is null if year is 0 or 1 -> less than 2.
 */
DX.isNullDate = function isNullDate(inputDate) {
	"use strict";
	var NULL_DATE_CONDITION = 2;
	var date = inputDate;
	if (typeof date === "string") {
		date = new Date(date);
	}
	return date.getFullYear() < NULL_DATE_CONDITION;
};
